import {ImpuestoDTO} from './ImpuestoDTO';
import {TipoRetencionDTO} from './TipoRetencionDTO';
import {ReferenciaCFEDTO} from './ReferenciaCFEDTO';

export class DetalleTipoCodigoDTO
{
  numero: number = 0;
  tipoCodigo: number;
  value: string;
  codigo: string;
}
